import { GetTransferConfigsResponse, MultiBurnPairConfig, PeggedPairConfig, TokenInfo, Token, Chain, ChainAssets } from "./AssetsInterfaces";

export const prepareTransferConfigs = (_transferConfig: GetTransferConfigsResponse) => {
    var chainTokenMap = new Map<number, TokenInfo[]>()
    var tokenSymbols = new Set<String>()

    var transferConfig = _transferConfig

    var multiBurnConfigs = prepareMultiburnConfigs(transferConfig.pegged_pair_configs) ?? []
    var peggedBridges = transferConfig.pegged_pair_configs

    peggedBridges.forEach(bridge => {
      let orgChainBlackList = chainTokenBlackList.get(bridge.org_chain_id) ?? []
      let pegChainBlackList = chainTokenBlackList.get(bridge.pegged_chain_id) ?? []

      if (orgChainBlackList.includes(bridge.org_token.token.symbol) || pegChainBlackList.includes(bridge.pegged_token.token.symbol)) {
        return 
      }

      let orgChainTokens = chainTokenMap.get(bridge.org_chain_id) ?? []

      const symbols = orgChainTokens.map(tokenInfo => { return tokenInfo.token.symbol })

      if (!symbols.includes(bridge.org_token.token.symbol)) {
          orgChainTokens.push(bridge.org_token)
          chainTokenMap.set(bridge.org_chain_id, orgChainTokens)
      }
      
      tokenSymbols.add(bridge.org_token.token.symbol)

      let pegChainTokens = chainTokenMap.get(bridge.pegged_chain_id) ?? []
      const pegToken = replaceTokenAddressForCanonicalTokenSwapIfNeeded(bridge.pegged_token, bridge.canonical_token_contract_addr)
      pegChainTokens.push(pegToken)
      chainTokenMap.set(bridge.pegged_chain_id, pegChainTokens)
      tokenSymbols.add(pegToken.token.symbol)
    })

    var multiBurnBridges = multiBurnConfigs

    var poolTokensMap = new Map<string, number>()

    var bridgedChainIds = prepareChainIds(transferConfig)

    const supportedChains = transferConfig.chains.filter((chainInfo) => {
      return bridgedChainIds.has(chainInfo.id)
    })

    supportedChains.forEach(chainInfo => {
        const id = chainInfo.id
        let tokens = chainTokenMap.get(id) ?? []

        const peggedTokenSymbol: string[] = transferConfig.pegged_pair_configs.map(peggedPair => {
            if (peggedPair.org_chain_id === id) {
                return peggedPair.org_token.token.symbol
            } else if (peggedPair.pegged_chain_id === id) {
                return peggedPair.pegged_token.token.symbol
            } else {
                return ""
            }
        }).filter(symbol => {
            return symbol.length > 0
        })

        const burnConfigTokenSymbol: string[] =  multiBurnConfigs?.map(burnConfig => {
            if (burnConfig.burn_config_as_org.chain_id === id) {
                return burnConfig.burn_config_as_org.token.token.symbol
            } else if (burnConfig.burn_config_as_dst.chain_id === id) {
                return burnConfig.burn_config_as_dst.token.token.symbol
            } else {
                return ""
            }
        }).filter(symbol => {
            return symbol.length > 0
        })

        const peggedSymbol = peggedTokenSymbol.concat(burnConfigTokenSymbol)

        let chainToken = transferConfig.chain_token[id]

        if (!chainToken) {
            return 
        }
        
        chainToken.token.filter(tokenInfo => {
            return !peggedSymbol.includes(tokenInfo.token.symbol)
        }).forEach(tokenInfo => {
            const symbol = tokenInfo.token.symbol
            const symbols = tokens.filter(tokenInfo => {
              return !tokenInfo.token.xfer_disabled
            }).map(tokenInfo => {
                return tokenInfo.token.symbol
            })

            const blackList = chainTokenBlackList.get(id)
            if (blackList?.includes(symbol)) {
              return 
            }

            poolTokensMap.set(symbol, (poolTokensMap.get(symbol) ?? 0) + 1)

            tokenSymbols.add(symbol)

            if (!symbols.includes(tokenInfo.token.symbol)) {
                tokens.push(tokenInfo)
            }  
        })

        chainTokenMap.set(id, tokens)
    })

    let poolBridges = 0
    
    poolTokensMap.forEach((value, key) => {
        if (key === "IMX") {
          console.log("value", value)
        }
        poolBridges += value * (value - 1)
    })

   
    return {    chainsNumber: supportedChains.length, 
                tokensNumber: tokenSymbols.size, 
                bridgesNumber: peggedBridges.length + multiBurnBridges.length + poolBridges, 
                chainAssetsList: generateChainAssetsList(chainTokenMap, transferConfig.chains),}
}

const prepareMultiburnConfigs = (pegged_pair_configs: Array<PeggedPairConfig>) =>  {
    const configsLength = pegged_pair_configs.length;
    const multiBurnConfigs: MultiBurnPairConfig[] = [];

    for (let i = 0; i < configsLength; i++) {
      for (let j = i + 1; j < configsLength; j++) {
        const peggedConfigI = pegged_pair_configs[i];
        const peggedConfigJ = pegged_pair_configs[j];
        if (
          peggedConfigI.org_chain_id === peggedConfigJ.org_chain_id &&
          peggedConfigI.org_token.token.symbol === peggedConfigJ.org_token.token.symbol
        ) {
          /// Only upgraded PegBridge can support multi burn to other pegged chain
          if (peggedConfigI.bridge_version === 2) {
            multiBurnConfigs.push({
              burn_config_as_org: {
                chain_id: peggedConfigI.pegged_chain_id,
                token: peggedConfigI.pegged_token,
                burn_contract_addr: peggedConfigI.pegged_burn_contract_addr,
                canonical_token_contract_addr: peggedConfigI.canonical_token_contract_addr,
                burn_contract_version: peggedConfigI.bridge_version,
              },
              burn_config_as_dst: {
                chain_id: peggedConfigJ.pegged_chain_id,
                token: peggedConfigJ.pegged_token,
                burn_contract_addr: peggedConfigJ.pegged_burn_contract_addr,
                canonical_token_contract_addr: peggedConfigJ.canonical_token_contract_addr,
                burn_contract_version: peggedConfigJ.bridge_version,
              },
            });
          }

          if (peggedConfigJ.bridge_version === 2) {
            multiBurnConfigs.push({
              burn_config_as_org: {
                chain_id: peggedConfigJ.pegged_chain_id,
                token: peggedConfigJ.pegged_token,
                burn_contract_addr: peggedConfigJ.pegged_burn_contract_addr,
                canonical_token_contract_addr: peggedConfigJ.canonical_token_contract_addr,
                burn_contract_version: peggedConfigJ.bridge_version,
              },
              burn_config_as_dst: {
                chain_id: peggedConfigI.pegged_chain_id,
                token: peggedConfigI.pegged_token,
                burn_contract_addr: peggedConfigI.pegged_burn_contract_addr,
                canonical_token_contract_addr: peggedConfigI.canonical_token_contract_addr,
                burn_contract_version: peggedConfigI.bridge_version,
              },
            });
          }
        }
      }

      return multiBurnConfigs
    }
}
  
const replaceTokenAddressForCanonicalTokenSwapIfNeeded = (
  tokenInfo: TokenInfo,
  canonical_token_contract_addr: string,
) => {
  if (canonical_token_contract_addr.length > 0) {
    /// Canonical Token Swap, should use canonical_token_contract_addr
    const tempTokenInfo = tokenInfo;
    const tempToken: Token = {
      symbol: tempTokenInfo.token.symbol,
      address: canonical_token_contract_addr,
      decimal: tempTokenInfo.token.decimal,
      xfer_disabled: tempTokenInfo.token.xfer_disabled,
    };

    const result: TokenInfo = {
      token: tempToken,
      name: tempTokenInfo.name,
      icon: tempTokenInfo.icon,
      max_amt: tempTokenInfo.max_amt,
      balance: tempTokenInfo.balance,
    };

    return result;
  }

  return tokenInfo;
};

const generateChainAssetsList = (map: Map<number, TokenInfo[]>, chains: Chain[]) => {
  const result: ChainAssets[] = []
  const higherPriorityChainIds: number[] = []
  chainNamesWithHigherPriority.forEach(name => {
    const targetChain = chains.find(chainInfo => { return chainInfo.name.includes(name) })
    if (targetChain) {
      higherPriorityChainIds.push(targetChain.id)
      const tokens = map.get(targetChain.id)
      if (tokens) {
        const blackList = chainTokenBlackList.get(targetChain.id)
        if (blackList) {
          result.push({chain: targetChain, tokens: blackListFilteredTokens(tokens, blackList)})
        } else {
          result.push({chain: targetChain, tokens})
        }
      }
    }
  })

  chains.filter(chainInfo => {
    return !higherPriorityChainIds.includes(chainInfo.id)
  }).sort((chainA, chainB) => {
    if (chainA.name < chainB.name) {
      return -1;
    }
    if (chainA.name > chainB.name) {
      return 1;
    }
    return 0;
  }).forEach(chainInfo => {
    const tokens =  map.get(chainInfo.id)
    if (tokens) {
      const blackList = chainTokenBlackList.get(chainInfo.id)
      if (blackList) {
        result.push({chain: chainInfo, tokens: blackListFilteredTokens(tokens, blackList)})
      } else {
        result.push({chain: chainInfo, tokens})
      }
    }
  })

  return result
}

const blackListFilteredTokens = (tokens: TokenInfo[], tokenSymbolBlackList: string[]): TokenInfo[] => {
  return tokens.filter(currentTokenInfo => {
    return !tokenSymbolBlackList.includes(currentTokenInfo.token.symbol) 
  }) 
}

/// Chain with priority 
const chainNamesWithHigherPriority = [
  "Ethereum",
  "Astar",
  "BNB Chain",
  "Avalanche",
  "Polygon",
  "Arbitrum",
  "Fantom",
  "Flow",
  "Metis",
  "Oasis",
  "Evmos",
  "Aurora",
  "Harmony",
  "Moonbeam",
  "Moonriver",
  "Optimism",
  "Boba",
  "OKExChain",
  "Heco",
  "Celo",
  "xDai",
];

const prepareChainIds = (transferConfig: GetTransferConfigsResponse) => {
  const allChainIds: number[] = transferConfig.chains
  .map(chain => {
    return chain.id;
  });

  const bridgedIds = new Set<number>();

  allChainIds.forEach(id1 => {
    if (bridgedIds.has(id1)) {
      return;
    }
    allChainIds.forEach(id2 => {
      if (id1 === id2) {
        return;
      }

      if (twoChainBridged(id1, id2, transferConfig)) {
        bridgedIds.add(id1);
        bridgedIds.add(id2);
      }
    });
  });

  return bridgedIds
}

const twoChainBridged = (
  chainId1: number,
  chainId2: number,
  transferConfig: GetTransferConfigsResponse,
) => {
  let peggedBridged = false;

  transferConfig.pegged_pair_configs.forEach(peggedPairConfig => {
    const bridged =
      (peggedPairConfig.org_chain_id === chainId1 &&
        peggedPairConfig.pegged_chain_id === chainId2) ||
      (peggedPairConfig.org_chain_id === chainId2 &&
        peggedPairConfig.pegged_chain_id === chainId1);
    peggedBridged = peggedBridged || bridged;
  });

  /// Skip pool based bridge check if two chains have pegged bridge
  if (peggedBridged) {
    return true;
  }

  const poolBasedTokensForChainId1 = transferConfig.chain_token[chainId1];
  const poolBasedTokensForChainId2 = transferConfig.chain_token[chainId2];

  let poolBasedBridged = false;
  if (
    poolBasedTokensForChainId1 &&
    poolBasedTokensForChainId1 !== undefined &&
    poolBasedTokensForChainId2 &&
    poolBasedTokensForChainId2 !== undefined
  ) {
    const poolBasedTokenSymbolsForChainId1: string[] = poolBasedTokensForChainId1.token
      .filter(tokenInfo => {
        return !tokenInfo.token.xfer_disabled
      })
      .map(tokenInfo => {
        return tokenInfo.token.symbol;
      });
    poolBasedTokensForChainId2.token.forEach(tokenInfo => {
      poolBasedBridged =
        poolBasedBridged ||
        (poolBasedTokenSymbolsForChainId1.includes(tokenInfo.token.symbol) &&
          !tokenInfo.token.xfer_disabled);
    });
  }
  return poolBasedBridged || peggedBridged;
};

const chainTokenBlackList = new Map([
  [1, ["IMX", "OOKI"]], // Ethereum Mainnet
  [56, ["BANANA", "sJADE", "IMX", "OOKI"]], // BNB
  [137, ["IMX"]], // Polygon
  [250, ["IMX"]], // Fantom
  [42161, ["MUX", "IMX"]], // Arbitrum
  [43114, ["IMX"]], // Avalanche
  [1285, ["IMX"]], // Moonriver
  [1666600000, ["IMX"]], // Harmony
  [16350, ["BANANA"]],
])